import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { Timeline } from 'primereact/timeline';
import { Button } from 'primereact/button';

import PropTypes from 'prop-types';
import { toCamelCaseString } from 'utils/func';
import { TIMEZONE_VN } from 'constant';

export default function ViewHistory({ data, visible, setVisible }) {
  const { t } = useTranslation();

  const [commentDialog, setCommentDialog] = useState({ visible: false, comment: '' });

  const formatAction = (value) => {
    // eslint-disable-next-line no-unused-vars
    const statusColorMapping = {
      new: 'var(--blue-500)',
      revise: 'var(--orange-500)',
      submit: 'var(--green-500)',
      approved: 'var(--green-500)',
      contracted: 'var(--cyan-500)',

      requestUpdate: 'var(--yellow-500)',
      requestExplanationPrequalification: 'var(--pink-500)',
      requestExplanationSpecialization: 'var(--pink-500)',
      requestExplanationFinance: 'var(--pink-500)',
      requestExplanationMidtermReport: 'var(--pink-500)',
      requestExplanationAcceptanceReport: 'var(--pink-500)',

      completeUpdateRequest: 'var(--cyan-500)',
      completeExplanationRequestPrequalification: 'var(--purple-500)',
      completeExplanationRequestSpecialization: 'var(--purple-500)',
      completeExplanationRequestFinance: 'var(--purple-500)',
      completeExplanationRequestMidtermReport: 'var(--purple-500)',
      completeExplanationRequestAcceptanceReport: 'var(--purple-500)',
    };

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {value.actionType === 'REQUEST_UPDATE' ? (
          <div
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Tag
              style={{ background: statusColorMapping[toCamelCaseString(value.actionType)] }}
              value={t(`projectProposal.viewHistory.status.${toCamelCaseString(value.actionType)}`)}
              rounded
            />
            <Button
              icon={<i className="pi pi-eye" style={{ fontSize: '1.2rem', lineHeight: 1 }} />}
              className="p-button-text"
              style={{
                height: '22.75px',
                width: '32px',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => setCommentDialog({ visible: true, comment: value.comment })}
              tooltip={t('projectProposal.viewHistory.tooltip')}
              tooltipOptions={{ position: 'top' }}
            />
          </div>
        ) : (
          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <Tag
              style={{ background: statusColorMapping[toCamelCaseString(value.actionType)] }}
              value={t(`projectProposal.viewHistory.status.${toCamelCaseString(value.actionType)}`)}
              rounded
            />
          </div>
        )}
      </div>
    );
  };
  const formatCreatedAt = (value) => {
    const datetime = new Date(value.createdAt);
    datetime.setHours(datetime.getHours() + 7);
    const formattedDatetime = datetime.toLocaleString('vi-VN', {
      timeZone: TIMEZONE_VN,
    });
    return <small className="text-color-secondary">{formattedDatetime}</small>;
  };

  return (
    <>
      <Dialog
        header={<p className="text-blue-500">{t('projectProposal.viewHistory.title')}</p>}
        visible={visible}
        position="center"
        style={{ width: '600px' }}
        onHide={() => setVisible(false)}
        draggable={false}
      >
        <Timeline value={data} opposite={formatAction} content={formatCreatedAt} />
      </Dialog>
      <Dialog
        header={<p className="text-blue-500">{t('projectProposal.viewHistory.titleComment')}</p>}
        visible={commentDialog.visible}
        style={{ width: '600px' }}
        onHide={() => setCommentDialog({ visible: false, comment: '' })}
        draggable={false}
      >
        <div
          style={{
            whiteSpace: 'pre-line',
            borderRadius: 8,
            padding: '16px 20px',
            fontSize: 16,
            color: '#222',
            minHeight: 60,
            border: '1px solid #e0e7ef',
          }}
        >
          {commentDialog.comment || (
            <span style={{ color: '#888' }}>{t('projectProposal.viewHistory.emptyComment')}</span>
          )}
        </div>
      </Dialog>
    </>
  );
}

ViewHistory.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};
